import React from 'react';
import { useImages } from '../../context';
import FramiProgress from './FramiProgress';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

const NoWrap = styled.div`
    white-space: nowrap;
    margin-right: 8px;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding: 2px;
    align-items: center;
`;

const PhotoUploadProgress = () => {
    const { uploadProgress } = useImages();
    const intl = useIntl();

    if (!uploadProgress || uploadProgress === 100) {
        return null;
    }
    return (
        <Wrapper>
            <NoWrap>
                {intl.formatMessage({ id: 'common.photos_upload' })}:
            </NoWrap>
            <FramiProgress percent={uploadProgress}/>
        </Wrapper>
    );
};

export default PhotoUploadProgress;
